import { NgClass } from '@angular/common';
import { Component, input, model } from '@angular/core';
import { Guidance } from '@models';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'bo-video-popup',
  templateUrl: './video-popup.component.html',
  standalone: true,
  imports: [AngularSvgIconModule, NgClass],
})
export class VideoPopupComponent {
  guidance = input.required<Guidance>();
  isVisible = model.required();
}
